/* eslint-disable no-undef, no-var */

// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        enableFuzzy: true,
    },
};

(function() {
    BoostPFS.inject(this);

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
        if (!suggestionElement) suggestionElement = this.$uiMenuElement;
        if (!searchElement) searchElement = this.$element;
        if (!searchBoxId) searchBoxId = this.id;
    };

    BoostPFS.prototype.beforeBuildSearchBox = function(id) {
        // Remove theme's instant search events
        var cloneSearchBar = jQ(id).clone();
        jQ(id).replaceWith(cloneSearchBar);


        if (Utils.InstantSearch.isFullWidthMobile()) {
            jQ(id).removeAttr('autofocus');
            if (jQ(id).is(':focus')) {
                jQ(id).blur();
            }
        }
    };

    BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
        // Close theme's search pop up
        if (isCloseSearchBox && window.$ && $.fancybox) {
            $.fancybox.close(true);
        }
    };

    SearchInput.prototype._onSubmit = function(event, redirect) {
        if (typeof isDisabledInstantSearch !== 'undefined' && isDisabledInstantSearch) return;

        if (typeof redirect == 'undefined') {
            redirect = this.isChangePage;
        }
        this.isChangePage = false;

        if (!redirect) {
            // Stop all default submit events
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            // Fix case can not get current value from input

            Globals.currentTerm = Utils.stripHtml(this.$element.val());
            if (!Globals.currentTerm && event && event.target) {
                Globals.searchTerm = Utils.stripHtml(event.target.value);
            }

            if ($('.search-submit-loader').length === 0) {
                const $loader = $('<div class="loader search-submit-loader"></div>');
                $('.header__search-button').html($loader);
            }

            // if API returned results or the suggestionCache has the search term, submit search
            // else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
            // then remove this attribute in the checkForSearchRedirect function
            const query = Utils.stripHtml(Globals.currentTerm.toString().trim());
            // Set recent searches
            InstantSearchOnclick.setOnClickRecentSearches(query);

            const decodeHtml = (() => {
                const tempElement = document.createElement('textarea');
                return (encodedString) => {
                    tempElement.innerHTML = encodedString;
                    return tempElement.value;
                };
            })();

            // Delay the form submission until the API returns some results
            let suggestionAttempts = 0;
            const suggestionInterval = setInterval(() => {
                const isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);

                // If the API returned results, either redirect or perform submit
                if (isApiReturnedResult) {
                    clearInterval(suggestionInterval);
                    const redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
                    if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
                        Utils.setWindowLocation(redirectUrl);
                    } else {
                        this.isChangePage = true;
                        this.$searchForm[0].submit();
                    }
                } else {
                    suggestionAttempts++;
                    if (suggestionAttempts > 300) {
                        clearInterval(suggestionInterval);
                        this.isChangePage = true;
                        this.$searchForm[0].submit();
                    }
                }
            }, 100);
        }
    };

    function buildMobileSearch() {
        setTimeout(() => {
            const isMobile = Utils.isMobile();
            if (isMobile && $('.boost-pfs-search-suggestion-mobile-top-panel').length === 0) {
                boostPFS.initSearchBox();
            }
        }, 200);
    }

    window.addEventListener('resize', buildMobileSearch, false);

    let inputValue;
    SearchInput.prototype.beforeRender = function() {
        inputValue = this.$element.val();
    };

    SearchInput.prototype.afterRender = function() {
        const currentValue = this.$element.val();
        if (!currentValue && inputValue) {
            this.$element.val(inputValue);
            // Dispatch the 'click' event to trigger the suggestion box
            setTimeout(() => {
                this.$element.trigger('click');
            }, 0);
        }
    };

    InstantSearchResultItemProduct.prototype.afterRender = function() {
        if (!this.data || !this.isShow) return;

        const [updatedPrice, compareAtPrice] = getPriceWithDiscount(this.data);

        let priceHtml = '<p class="boost-pfs-search-suggestion-product-price">';

        if (compareAtPrice > updatedPrice) {
            if (Shopify.theme_settings.show_discounts && !Shopify.theme_settings.show_discounts_by_price_history) {
                priceHtml += '<s>' + compareAtPrice + '</s>&nbsp';
            }
            priceHtml += '<span class="boost-pfs-search-suggestion-product-sale-price">';
        } else {
            priceHtml += '<span class="boost-pfs-search-suggestion-product-regular-price">';
        }

        priceHtml += updatedPrice + '</span></p>';

        this.$element.find('.boost-pfs-search-suggestion-product-price').html(priceHtml);
    };

    InstantSearchApi.beforeCall = function(searchTerm) {
        let query = '';
        if (searchTerm !== '') {
            query = searchTerm;
        }

        Globals.instantSearchQueryParams.q = query;
    };
})();

{
    // Activate the suggestion box on right click paste into
    const searchInputEl = document.querySelector('input[name="q"]');
    if (searchInputEl) {
        searchInputEl.addEventListener('paste', () => {
            setTimeout(() => {
                searchInputEl.dispatchEvent(new Event('click'));
            }, 0);
        });
    }
}
